import { EventEmitter } from 'events';
import assign from 'object-assign';
import AdminAppDispatcher from 'dispatcher/AdminAppDispatcher';
import AdminConstants from 'constants/AdminConstants';
import EquipmentWebAPIUtils from "../utils/EquipmentWebAPIUtils";
const CHANGE_EVENT = 'change';
let downloaded = false;
const EquipmentCsvStore = assign({}, EventEmitter.prototype, {
    addChangeListener(callback) {
        this.on(CHANGE_EVENT, callback);
    },
    removeChangeListener(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },
    emitChange() {
        this.emit(CHANGE_EVENT);
    },
    isFileDownloaded() {
        return downloaded;
    }
});
AdminAppDispatcher.register((payload) => {
    const data = payload.action.data;
    switch (payload.action.type) {
        case AdminConstants.ActionTypes.DOWNLOAD_EQUIPMENT_CSV: {
            downloaded = false;
            EquipmentWebAPIUtils.downloadShipmentsCsv(data.filters, data.limit, data.activeColumns, function () {
                downloaded = true;
                EquipmentCsvStore.emitChange();
            });
            break;
        }
        default:
    }
});
export default EquipmentCsvStore;
